const jwt_customizer = {
    general: 'Đã xảy ra lỗi khi tùy chỉnh claim của token. Vui lòng thử lại sau.',
    can_not_create_for_admin_tenant: 'Không thể tạo trình tùy chỉnh token cho admin tenant.',
};
export default Object.freeze(jwt_customizer);
